import { CAPABILITY_KEYS } from "../hooks/useCompanyCapabilities";

/**
 * Map API investor_capabilities / profile.capabilities to portal capability keys.
 */
export function mapApiCapabilitiesToPortal(apiCaps = {}) {
  return {
    [CAPABILITY_KEYS.INVESTOR_PORTAL]: Boolean(apiCaps.investor_portal_enabled),
    [CAPABILITY_KEYS.INVESTMENT]: Boolean(apiCaps.investment_enabled),
    [CAPABILITY_KEYS.MARKETPLACE]: Boolean(apiCaps.marketplace_enabled),
    [CAPABILITY_KEYS.COOPERATIVE_REQUEST]: Boolean(apiCaps.cooperative_request_enabled),
    [CAPABILITY_KEYS.REAL_ESTATE]: Boolean(apiCaps.real_estate_enabled),
    investorSignupEnabled: Boolean(apiCaps.investor_signup_enabled),
  };
}

export function extractCapabilitiesFromCoopData(coopData) {
  if (!coopData) return null;
  // Prefer investor_capabilities from public/company payloads.
  // Do not treat unrelated `capabilities` blobs as investor flags (avoids false positives on login).
  const raw = coopData.investor_capabilities;
  if (!raw || typeof raw !== "object") {
    if (coopData.capabilities && typeof coopData.capabilities === "object") {
      // Profile payloads may nest as capabilities with the same investor_* keys.
      if (
        "investor_portal_enabled" in coopData.capabilities ||
        "investor_signup_enabled" in coopData.capabilities
      ) {
        return mapApiCapabilitiesToPortal(coopData.capabilities);
      }
    }
    return null;
  }
  return mapApiCapabilitiesToPortal(raw);
}
